"use client";
import { StaticImageData } from "next/image";
import ToolFeaturedArea, {
  THeroSectionInfoType,
} from "@/components/tools/ToolFeatured/ToolFeaturedArea";
import AdBanner from "@/components/Advertisement/AdBanner";
import TranslatorCoreSection from "@/components/tools/ToolFunctional/translator/TranslatorCoreSection";
import { PageInfoProps } from "../summarizer/root";
import TopInfoImageSection, {
  TopImageInfoType,
} from "@/components/tools/ToolsCommon/TopInfoImageSection";
import { StepsSectionFeatureProps } from "@/components/tools/ToolsCommon/StepsSection";
import TranslatorConclusionSection, {
  TranslatorSectionFeatureProps,
} from "@/components/tools/ToolsCommon/TranslatorConclusion";
import ToolTopArea from "@/components/tools/ToolTop/ToolTopArea";
import AiToolsFaq, {
  IFaqList,
} from "@/components/tools/ToolsCommon/AiToolsFaq";
import ThreeStepsSection from "@/components/tools/ToolsCommon/ThreeStepsSection";
import AdvTools from "@/components/tools/AdvTools/AdvTools";

export type TAIPropTypes = {
  params: {
    pageInfo: PageInfoProps;
    heroSectionInfo: THeroSectionInfoType;
    conclusionSectionFeatures: TranslatorSectionFeatureProps[];
    stepsSectionFeatures: StepsSectionFeatureProps[];
    topInfoSectionFeature: TopImageInfoType;
    faqList: IFaqList[];
  };
};

export type TFeatureList = {
  title: string;
  subtitle: string;
  featuredImg: StaticImageData;
};

const TranslatorPageRoot = ({ params }: TAIPropTypes) => {
  const {
    pageInfo,
    heroSectionInfo,
    topInfoSectionFeature,
    stepsSectionFeatures,
    conclusionSectionFeatures,
    faqList,
  } = params;

  return (
    <>
      <ToolTopArea pageInfo={pageInfo}>
        <div className="relative z-10 w-full overflow-hidden">
          <TranslatorCoreSection />
        </div>
      </ToolTopArea>
      <AdvTools
        title={<>Get Kroolo, The best of {" "}
          <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
            AI Translator
          </span>
        </>
        }
        btnText="Try it free"
      />
      <ThreeStepsSection
        fromTranslate={true}
        featureArray={stepsSectionFeatures}
        title="How to Translate a Document Using Kroolo AI’s Online Translator"
      />
      <TopInfoImageSection topInfoSection={topInfoSectionFeature} />
      <ToolFeaturedArea heroSectionInfo={heroSectionInfo} />
      <TranslatorConclusionSection
        title="What Documents Can You Translate with Our AI Language Translator?"
        subtitle="Translate a wide range of documents, including"
        featureArray={conclusionSectionFeatures}
      />
      <AiToolsFaq faqTitle="AI Translator FAQs" faqList={faqList} />
      <AdBanner />
    </>
  );
};

export default TranslatorPageRoot;
